import { JAKARTA_AREA, LOCAL_STORAGE } from 'app/commons/constants'
import {
  IAccount,
  IBookingDetails,
  IBookingSummary,
  IContract,
  IDepot,
  IDestinationAddress,
  IDetail,
  IDeviceInfo,
  IDriver,
  IFtlRelation,
  IGoodsInsurance,
  IInformationState,
  ILocation,
  IMaker,
  INoteCustomer,
  IPackage,
  IPickupAddress,
  IPort,
  IProviderRelation,
  ISchedule,
  IStage,
  IWorkTime,
} from 'app/interface/IBooking'
import { IConfig } from 'app/interface/IConfig'
import { IPayment } from 'app/interface/IPayment'
import { IReimbursements } from 'app/interface/IReimbursement'
import { ISettingSystem, ISettingsFtl } from 'app/interface/ISetting'

export const initialPort: IPort = {
  address: '',
  cityName: '',
  iconUrl: '',
  infoLink: '',
  islandId: 0,
  islandName: '',
  location: { latitude: 0, longitude: 0 },
  portId: '',
  portName: '',
  portNameId: '',
  unPortId: '',
  imgPort: '',
  isPickupPort: undefined,
  isFrom: undefined,
}
export const initialMaker: IMaker = {
  map: {},
  lat: 0,
  lng: 0,
  rotation: {},
  typeMarker: '',
  styles: {
    urlIcon: '',
    labelText: '',
    size: '',
    color: '',
    fontSize: '',
    fontWeight: 0,
    className: '',
    rotate: '',
  },
  draggable: false,
}

export const initialPackage: IPackage = {
  code: '',
  description: '',
  iconUrl: '',
  id: '',
  updatedDate: '',
  additionalServices: '',
  commodityId: '',
  handlingUnitId: '',
  height: 0,
  itemAttachmentFiles: undefined,
  length: 0,
  unitQuantity: 0,
  weight: 0,
  width: 0,
  handlingUnitName: '',
  commodityName: '',
  totalUnitQuantity: 0,
  orderId: 0,
}

export const initialNoteCustomer: INoteCustomer = {
  pickupAddress: {
    id: '',
    note: '',
  },
  destinationAddresses: [
    {
      id: '',
      note: '',
    },
  ],
}
export const initialGoodsInsurance: IGoodsInsurance = {
  id: '',
  coverage: '',
  fee: 0,
  order: 0,
}

export const initialWorkTime: IWorkTime = {
  day: '',
  from: '',
  to: '',
}

export const initialLocation: ILocation = {
  latitude: 0,
  longitude: 0,
  lat: 0,
  lng: 0,
}

export const initialDepot: IDepot = {
  loadType: '',
  cyLat: 0,
  cyAddress: '',
  unPortId: '',
  cyLong: 0,
  cyId: 0,
  portName: '',
  cyName: '',
  picName: '',
  picPhoneNumber: '',
  notes: '',
  workTimes: [initialWorkTime],
}

export const initialPickupAddress: IPickupAddress = {
  id: '',
  addMe: false,
  addressType: '',
  status: null,
  address: '',
  shortAddress: null,
  note: null,
  contactName: '',
  contactPhone: '',
  contactDialCode: '',
  isPay: false,
  jsonAddress: '',
  depot: initialDepot,
  port: initialPort,
  location: initialLocation,
  locationName: null,
}

export const initialDestinationAddress: IDestinationAddress = {
  id: '',
  addMe: false,
  addressType: '',
  status: '',
  address: '',
  shortAddress: '',
  note: '',
  contactName: '',
  contactPhone: '',
  contactDialCode: '',
  isPay: false,
  jsonAddress: '{}',
  depot: initialDepot,
  port: initialPort,
  location: initialLocation,
  locationName: '',
}

export const initialDetail: IDetail = {
  requireSignature: false,
  truckingFees: 0,
  vehicleTypeId: 0,
  distance: 0,
  distanceFees: 0,
  travelTime: 0,
  totalPrice: 0,
  ratio: 0,
  adminFee: 0,
  sellingRate: 0,
  oceanLandFreightFee: 0,
  extraLoadingServicesFee: 0,
  onlinePaymentServiceFee: 0,
  loadingServicesSelected: false,
  dayBufferFinalStop: 0,
  dayBufferPaymentDeadline: 0,
  whoPaymentTransactionFee: false,
  paymentStatus: null,
  amount: null,
  internalNote: null,
  review: null,
  timeType: '',
  reimbursementFee: 0,
  paidAt: null,
  transitTimeEta: 0,
  additionalServices: [],
  totalPaid: undefined,
}

export const initialDeviceInfo: IDeviceInfo = {
  fcmToken: '',
  osVersion: '',
  deviceType: '',
  deviceId: '',
  deviceName: '',
  screenDpi: '',
  appVersion: '',
  manufacturer: '',
  appsflyerUid: '',
}
export const initialAccount: IAccount = {
  customerId: '',
  customerName: '',
  customerPhone: '',
  customerEmail: '',
  companyId: '',
  companyName: '',
  companyEmail: '',
  companyPhone: '',
  staffId: '',
  staffName: '',
  staffEmail: '',
  deviceInfo: initialDeviceInfo,
}

export const initialSetting: ISettingsFtl = {
  sendingEtaPeriod: 0,
  chatEnable: false,
  networkEffectSmsEnable: false,
  timeToReviewChanges: 0,
}

export const initialSettingSystem: ISettingSystem = {
  buff_depo_closing_time: {
    value: '',
  },
  day_buffer_final_stop: {
    value: '',
  },
  transaction_fee_spil: {
    value: '',
  },
  icon_trucking_vendor: {
    value: '',
  },
  day_buffer_payment_deadline: {
    value: '',
  },
  who_payment_transaction_fee: {
    value: '',
  },
}

export const initialReimbursements: IReimbursements = {
  id: 0,
  fees: 0,
  isConfirmed: false,
  locationId: 0,
  vehicleTypeReimbursementId: 0,
  reimbursement_name: '',
  name: '',
}
export const initialFtlRelation: IFtlRelation = {
  ftlId: '',
  status: '',
  employerIds: [''],
  acceptedAt: '',
  acceptedAtLat: 0,
  acceptedAtLng: 0,
  arrivedAt: 0,
  arrivedAtLat: 0,
  arrivedAtLng: 0,
  completedAt: 0,
  completedAtLat: 0,
  completedAtLng: 0,
  originalCommissionValue: 0,
  commissionValue: '',
  channelName: '',
  commissionType: 0,
  staff: null,
  driver: null,
  fleet: null,
  vehicle: null,
  vehicleType: {
    id: 0,
    name: '',
  },
  location: null,
  locations: [],
  reason: null,
  settings: initialSetting,
  vehicleServiceType: null,
  driverIsGoingToPickup: false,
  isReimbursementConfirmed: false,
  reimbursements: [initialReimbursements],
  reviewTimeoutAt: null,
}

export const initialSchedule: ISchedule = {
  scheduleDate: '',
  scheduleTime: '',
  scheduleDay: '',
  vesselId: '',
  vesselName: '',
  berthingDate: '',
  closingDate: '',
  voyageNumber: '',
}
export const initialProviderRelation: IProviderRelation = {
  bookingNumber: '',
  pricePerCbm: 0,
  bookSessionId: '',
  status: '',
  statusDate: null,
  totalPrice: 0,
  adminFee: 0,
  depotAddress: '',
  vesselId: null,
  vesselName: null,
  voyageNumber: null,
  containerNumber: null,
  totalWeight: 0,
  depotLong: 0,
  depotLat: 0,
  unLoadPortId: '',
  unDiscPortId: '',
  depotName: '',
  pickupAddress: '',
  totalCbm: 0,
  deliveryAddress: '',
  totalnmile: null,
  depotId: 0,
  supplier: null,
  consignee: null,
  loadPortName: null,
  discPortName: null,
  isVesselDeparted: false,
  etb: '',
  vesselDeparture: null,
  closingTime: null,
  vesselArrival: null,
  electronicPodDocuments: [],
}
export const initialStage: IStage = {
  stageId: 0,
  stageName: '',
  subTitle: '',
  status: 0,
  completedTime: '',
}

export const initialBookingDetails: IBookingDetails = {
  id: '',
  code: '',
  serviceType: '',
  statusId: 0,
  statusValue: '',
  headerStatus: '',
  headerStatusId: 0,
  headerTitle: '',
  paymentMethod: '',
  bankName: '',
  title: '',
  countryCode: '',
  pickupDate: '',
  contractDetailId: '',
  goodsInsurance: initialGoodsInsurance,
  pickupAddress: initialPickupAddress,
  destinationAddresses: [initialDestinationAddress],
  items: [initialPackage],
  notes: [],
  attachmentFiles: [],
  detail: initialDetail,
  account: initialAccount,
  ftlRelation: initialFtlRelation,
  schedule: {
    index: '',
    description: '',
    schedules: [initialSchedule],
  },
  providerRelation: initialProviderRelation,
  stages: [initialStage],
  requestedAt: '',
  bookingMarkedAsFavorite: false,
  canceledAt: null,
  isDeleted: false,
  createdBy: '',
  createdAt: '',
  modifiedBy: '',
  modifiedAt: '',
  addresses: [],
}

export const initialPayment: IPayment = {
  method: '',
  bankInfo: {
    bankCode: '',
    bankName: '',
  },
  timePay: '',
  payInfo: {
    reference_number: '',
    bank_code: '',
    payment_amount: null,
    payment_number: '',
    customer_name: '',
    payment_info: '',
    expired_on: '',
  },
}

export const initialBooking = {
  isOSA: false,
  currentStepBreadcrumb: 0,
  schedule: {
    index: '',
    description: '',
    schedules: [initialSchedule],
  },
  vesselPrevious: undefined,
  pickupAreaId: localStorage.getItem(LOCAL_STORAGE.AREA_ID) || JAKARTA_AREA,
}

export const initEditBookingInfo = {
  locations: {
    id: '',
    serviceType: '',
    pickupAddress: initialPickupAddress,
    destinationAddresses: [initialDestinationAddress],
    schedule: {
      index: '',
      description: '',
      schedules: [initialSchedule],
    },
  },
  items: {},
}

export const initBookingSummary: IBookingSummary = {}

export const initialChat = {
  unconsumedMessagesCount: 0,
  isOpenChat: false,
}

export const initialConfig: IConfig = {
  configFTL: {},
  data: {},
}

export const initialContact: IContract = {
  isContactPickup: false,
  isContactDestination: false,
  contacts: {
    business: {},
    personal: {},
  },
}

export const initialDriver: IDriver = {}

export const initialETAInfo = { duration: 0, distance: 0 }

export const initInformationState: IInformationState = {
  listData: {
    units: [],
    commodities: [],
    ports: [],
  },
  items: [],
  collapseList: [],
}
